
import { SORT_DIRECTION } from '../../../../common/constants/sortDirection';
import { SORT_ICON_STATE_COLOR } from '../constants/sortIconStateColor';


export const getNextSortValue = (currentSort, hasNoSort) => {
  if (currentSort === SORT_DIRECTION.ASC) {
    return SORT_DIRECTION.DESC;
  }

  if (currentSort === SORT_DIRECTION.DESC && hasNoSort) {
    return null;
  }

  return SORT_DIRECTION.ASC;
};

export const getSortColor = (isActive, isHovered) => {
  if (isActive) {
    return SORT_ICON_STATE_COLOR.ACTIVE;
  }

  if (isHovered) {
    return SORT_ICON_STATE_COLOR.HOVERED;
  }

  return SORT_ICON_STATE_COLOR.NOT_ACTIVE;
};